import * as React from 'react';
import { Control } from 'react-redux-form';
import { DynamicSelect } from '@common/components';

export const Select = (props: any) => (
  <Control.select
    model={props.returnModelValue ? props.model.value : props.model}
    component={DynamicSelect}
    mapProps={{
      ...props
    }}
    validators={props.validators}
    disabled={props.disabled}
  />
);



// WEBPACK FOOTER //
// ./src/common/components/select/select.tsx